import { Link_default } from "./chunk-EFRJ3CR6.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Breadcrumb/Breadcrumb.Item.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "a";
var BreadcrumbItem = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      className,
      isCurrentPage = false
    } = _b,
    rest = __objRest(_b, ["as", "className", "isCurrentPage"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */React.createElement("li", {
    className: "pd-breadcrumb__item"
  }, /* @__PURE__ */React.createElement(Link_default, __spreadProps(__spreadValues({
    ref,
    as: Component
  }, rest), {
    variant: "secondary",
    className: clsx(className, "pd-breadcrumb__link", isCurrentPage && "pd-breadcrumb__link--current"),
    "aria-current": isCurrentPage ? "page" : void 0
  })), !isCurrentPage && /* @__PURE__ */React.createElement(Icon_default, {
    size: "em",
    className: "pd-breadcrumb__separator",
    icon: "chevron-right"
  }));
});
var Breadcrumb_Item_default = BreadcrumbItem;
export { Breadcrumb_Item_default };